export default "__VITE_ASSET__BXqKQyje__"